import { cn } from '@/lib/utils';
import { moodOptions, type MoodOption } from '@/types/index';

interface MoodSelectorProps {
  selected: string | null;
  onChange: (mood: string | null) => void;
  className?: string;
}

export default function MoodSelector({ selected, onChange, className }: MoodSelectorProps) {
  const handleClick = (mood: MoodOption) => {
    onChange(selected === mood.id ? null : mood.id);
  };

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {moodOptions.map(mood => (
        <button
          key={mood.id}
          type="button"
          onClick={() => handleClick(mood)}
          className={cn(
            "flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm transition-all border",
            selected === mood.id
              ? "bg-primary/10 border-primary text-primary font-medium"
              : "bg-secondary border-transparent text-muted-foreground hover:bg-accent"
          )}
        >
          <span>{mood.emoji}</span>
          <span>{mood.label}</span>
        </button>
      ))}
    </div>
  );
}
